import StateModel from "Cart/store/models/stateModel";
import InvalidArgumentException from "Exceptions/invalidArgumentException";
import { bus } from "Util/bus.js";

const shoppingCartKey = "shoppingCart";

const saveStoreSnapshot = (state) => {
	if (!state) throw new InvalidArgumentException("state", state);
	localStorage.setItem(shoppingCartKey, JSON.stringify(state));
};

const isProductExist = (products, id) => {
	let exist = products.some(function (product) {
		return product.id === id;
	});
	return exist;
}

const mutations = {
	/** @param {StateModel} state */
	ADD_PRODUCT_TO_CART(state, item) {
		if (item === null || item === undefined) throw new InvalidArgumentException("item", item);
		if (item.id === null) throw new InvalidArgumentException("item.id", item.id);
		if (item.productName === null) throw new InvalidArgumentException("item.productName", item.productName);
		if (item.count === null) throw new InvalidArgumentException("item.count", item.count);
		if (item.price === null) throw new InvalidArgumentException("item.price", item.price);

		item.price = (item.price.replace(",", ".") * 1).toFixed(2);
		if (!isProductExist(state.products, item.id)) {
			state.products.push(item);
			saveStoreSnapshot(state);
		}
		bus.$emit("productAdded", item.productName);
	},
	REMOVE_PRODUCT_FROM_CART(state, id) {
		if (isProductExist(state.products, id)) {
			state.products = state.products.filter(product => product.id !== id);
			saveStoreSnapshot(state);
		}
	},
	UPDATE_PRODUCT_COUNT(state, payload) {
		if (payload === null || payload === undefined) throw new InvalidArgumentException("payload", payload);
		if (payload.id === null) throw new InvalidArgumentException("payload.id", payload.id);
		if (payload.count === null) throw new InvalidArgumentException("payload.count", payload.count);

		if (isProductExist(state.products, payload.id)) {
			let newProductArray = state.products.map(function (product) {
				if (product.id === payload.id) {
					product.count = payload.count;
				}
				return product;
			});
			state.products = newProductArray;
			saveStoreSnapshot(state);
		}
	},
	CLEAR_CART(state) {
		state.products = new Array();
		state.comment = null;
		saveStoreSnapshot(state);
	},
	SET_COMMENT(state, comment) {
		state.comment = comment;
		saveStoreSnapshot(state);
	},
	SET_ITEM_CHECKED(state, id) {
		if (isProductExist(state.products, id)) {
			state.products = state.products.map((product) => {
				if (product.id === id) {
					product.checked = true;
				}

				return product;
			});
			saveStoreSnapshot(state);
		}
	},
	RESET_ITEM_CHECKED(state, id) {
		if (isProductExist(state.products, id)) {
			state.products = state.products.map((product) => {
				if (product.id === id) {
					product.checked = false;
				}

				return product;
			});
			saveStoreSnapshot(state);
		}
	},
	REMOVE_CHECKED_ITEMS(state) {
		let checkedItems = state.products.filter(product => product.checked === true);

		checkedItems.forEach((item) => {
			if (isProductExist(state.products, item.id)) {
				state.products = state.products.filter(product => product.id !== item.id);
			}
		});

		saveStoreSnapshot(state);
	}
};
export { mutations };